<template>
  <div style="visibility:visible">
    <mall-header :totals="tableData.length"></mall-header>
    <div >
    <mall-bread >
        <!-- <span>我的购物车</span> -->
        <span to="/cart" style="color:#999">我的购物车</span>
    </mall-bread>
    <div  class="cart-div" id='cartId' v-if="tableData.length"  >
      <div style=" float: left;margin: 30px;">
          <span class="cart-title">全部商品  {{tableData.length}}</span> 
      </div>
      <!-- <div class="selectAll-css" :indeterminate="isIndeterminate" @change="handleCheckAllChange">全选</div> -->
      <div class="selectAll-css"  :indeterminate="isIndeterminate"   @click="handleCheckAllChange()">全选</div>
      <el-table ref="multipleTable"  v-loading="fullscreenLoading"  :header-cell-style="{height: '40px',background: '#F6F6F6',color:'#666666','font-size': '14px','font-family': 'PingFang SC','font-weight': '500'}"
        :data="tableData"
        @selection-change="handleSelectionChange"
        :row-style="{height: '110px', 'padding-right': '30px'}"
        tooltip-effect="dark"
        style="    width: 1140px; margin-left: 30px;border-left: 1px solid #eee;border-right: 1px solid #eee;    margin-bottom: 20px; ">
        <el-table-column 
          type="selection"
          label="全选"
          width="60">
        </el-table-column>
        <el-table-column
          label="商品" 
          header-align="center"
          align="left"
          width="400">
          <template scope="scope">
            <div style="display:flex;align-items: center;">
              <img :src="scope.row.serviceItem.imgUrl" @click="openDetails(scope.row)" class="cart-productName-img"  >
              <!-- <span class="cart-span-productName"   @click="openDetails(scope.row)">{{scope.row.serviceItem.name}}</span> -->
              <el-tooltip placement="right"  :open-delay="500"  :disabled="showTip" :content='scope.row.serviceItem.name' >
              <span class="cart-span-productName" @mouseenter="showTips($event)"  @click="openDetails(scope.row)">{{scope.row.serviceItem.name}}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          style="height: 40px;background: #F6F6F6;"
          label="单价"
          header-align="left"
          align="left"
          width="100">
          <template scope="scope">¥ {{scope.row.serviceItem.unitPrice}}
            </template>
        </el-table-column>
        <el-table-column
          prop="productNum" style="height: 40px;background: #F6F6F6;"
          label="数量"
          header-align="center"
          align="center"
          width="260"
          show-overflow-tooltip>
          <template scope="scope">
          <el-input-number v-model="scope.row.quantity"  class="cart-number" :min="1" size="small" 
          @change="handleChange(scope)"></el-input-number>
          <span >{{scope.row.serviceItem.unit}}</span>
        </template>
        </el-table-column>
        <el-table-column
          style="height: 40px;background: #F6F6F6;"
          label="小计"
           header-align="center"
          align="center"
          width="150"
          show-overflow-tooltip>
          <template scope="scope" >
            <span class="cart-span-total" style="">¥ {{scope.row.amount}}</span>
            </template>
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="170"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button @click="deleteProduct(scope.row)" class="cart-opertion-delete"  type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="tableData.length" style="height:80px">
      <div :class="isFixed?'cart-low-div-fixed':'cart-low-div'">
          <div class="cart-select-div">
              <el-checkbox  v-model="ischecked" :indeterminate="isIndeterminate"  style="padding-left: 2px;" @change="handleCheckAllChange()">全选</el-checkbox>
              <span  :class="isClick?'cart-delete-css':'cart-delete-css1' "   @click="deleteBatch()">删除选中的商品</span>
           </div>
            <div class="cart-selectALL-div" >
              <div style="       float: left;line-height: 22px; margin-top: 29px;">
              <span style="color: #333;">已选择</span>
              <span class="cart-selectALL-Num" > {{selectProduct}}</span>
              <span style=" color: #333;">件&ensp; |&ensp; 应付总金额：</span>
              </div>
                <span class="cart-span-money" style="">¥ {{totalMoney}}</span>
                <button class="endButton"  @click="statement()" >去结算</button>
            </div>
        </div>
        </div>
        <el-backtop   style="right: initial;bottom: 40px;">
            <div class="el-backtop-div">
              <img src="../../static/images/backtop.png" style="margin-top: 15px;" />
            </div>
        </el-backtop>
    </div>
    <!-- <mall-footer  ></mall-footer> -->
    <div v-if="!tableData.length" class="cart-defualt-div"  >
        <div v-loading="fullscreenLoading">
          <img src="../../static/images/购物车空.png" class="cart-defualt-img" alt="" >
          <p class="cart-defualt-font" >购物车什么都没有~</p>
          <span class="cart-defualt-font1">立即</span>
          <span class="cart-defualt-font2" @click="openGoodList()">去商城逛逛</span>
          <span class="cart-defualt-font3" >吧</span>
        </div>
      </div>
        </div>
        <!-- <div :style="isFixed?'clear: both;height: 0px;':'clear: both;height: 0px;'"></div> -->
        <div style="position: fixed;
    left: 0px;
    bottom: 0px;
    width: 100%;
    z-index: -1;">
    <mall-footer></mall-footer>
        </div>
      <!-- <el-backtop   style="right: initial;bottom: 40px;">
          <div class="el-backtop-div">
            <img src="../../static/images/backtop.png" style="margin-top: 15px;" />
          </div>
      </el-backtop> -->
  </div>
</template>
<script>
import "../assets/css/cart.css"
import mallHeader from '../components/header.vue'
import mallFooter from '../components/footer.vue'
import mallBread from '../components/navbread.vue'
import http from '../api/public'
import axios from 'axios'
    export default{
        data(){
            return{
              totalMoney:0,//分页总条数
              selectProduct:0,
              ischecked: false,
              checkAll: false,
              showTip : false,
              isFixed:false,
              isClick:true,
              isIndeterminate: false,
              fullscreenLoading: true,
              //totals:"",
              tableData: [],//购物车列表集合
              multipleSelection: []//全选数组
            }
        },
        mounted(){
          this.getCartNum();
        },
        methods:{
          //购物车列表
          getCartNum(){
            this.fullscreenLoading= true;
            var that = this;
            axios.get('/mallApi/mall/shopCart/list',{headers:{"token": localStorage.getItem("Authorization")}}).then((res) => {  
              res = res.data;
              if(res.success){
                that.tableData = res.result;
                if(res.result){
                  for(var i=0;i<that.tableData.length;i++){
                    that.tableData[i].serviceItem.imgUrl =  "/mallApi"+ that.tableData[i].serviceItem.imgUrl;
                    that.tableData[i].oldQuantity = that.tableData[i].quantity;
                    that.tableData[i].amount =http.changeUnitPrice(that.tableData[i].amount)
                    that.tableData[i].serviceItem.unitPrice =http.changeUnitPrice(that.tableData[i].serviceItem.unitPrice)
                  }
                }
              }else {
                if(res.code == 401 || res.code == 400) {
                  http.setLocalStorge();
                  this.$router.push({path: '/login'});
                }else{
                   that.$message({
                      showClose: true,
                      message: '操作失败！',
                      type: 'error'
                    });
                }
              }
              this.fullscreenLoading= false;
            });
            
            setTimeout(() => {
              this.getHeight();
            }, 500);
          },
          //删除商品
          deleteProduct(data){
            var that = this;
            axios.defaults.headers ={
                "content-type": "application/json",
                "token": localStorage.getItem("Authorization")
            }
            axios.delete('/mallApi/mall/shopCart/delete', {
                params: {
                  'id': data.id
                }
              }).then(res => {
                 res = res.data;
                  if(res.success){
                    //localStorage.setItem('cartCount',this.tableData.length)
                    that.$message({
                      showClose: true,
                      message: '操作成功！',
                      type: 'success'
                    });
                   this.getCartNum();
                  }else {
                    if(res.code == 401 || res.code == 400) {
                       http.setLocalStorge();
                      this.$router.push({path: '/login'});
                    }else{
                        that.$message({
                          showClose: true,
                          message: '操作失败！',
                          type: 'error'
                        });
                    }
                  }
            })
          },
          //批量删除
          deleteBatch(){
            if(this.multipleSelection.length>0){
              var tempArr = this.multipleSelection;
              var ids =[];
              for(var i=0;i<tempArr.length;i++){
                  //ids +=tempArr[i].id+","
                   ids.push(tempArr[i].id)
              }
              var queryDa  = ids.join();
              var that = this;
              axios.defaults.headers ={
                "content-type": "application/json",
                "token": localStorage.getItem("Authorization")
              }
              axios.delete('/mallApi/mall/shopCart/deleteBatch', {
                  params: {
                    'ids': queryDa
                  }
                }).then(res => {
                  res = res.data;
                    if(res.success){
                      that.$message({
                        showClose: true,
                        message: '操作成功！',
                        type: 'success'
                      });
                       this.getCartNum();
                    }else {
                      if(res.code == 401 || res.code == 400) {
                       http.setLocalStorge();
                        this.$router.push({path: '/login'});
                      }else{
                        that.$message({
                          showClose: true,
                          message: '操作失败！',
                          type: 'error'
                        });
                      }
                    }
              });
            }else{
              this.$message({
                    showClose: true,
                    message: '请您至少选择1件商品！',
                  });
            }
          },
          //全选change 事件
          handleSelectionChange(val) {
            let vlength = val.length;
            this.multipleSelection = val;
            this.checkAll = vlength === this.tableData.length
            this.isIndeterminate = vlength > 0 && vlength < this.tableData.length
            if(val.length>0){
              this.isClick = false;
              this.ischecked =true;
              this.selectCountNum(val)
            }else{
              this.isClick = true;
              this.ischecked =false;
              this.totalMoney= 0
              this.selectProduct= 0
            }
             
          },
          //计算商品件数及金额
          countNum(scope){
            //debugger
            var quantity = scope.row.quantity;
            var unitPrice = scope.row.serviceItem.unitPrice;
            scope.row.amount= Number(quantity * unitPrice).toFixed(2);
            var da  = this.$refs.multipleTable.selection;
             this.handleSelectionChange(da)
          },
          //勾选列表数据后变化数量计算总金额
           selectCountNum(datas){
            this.totalMoney =0;
            this.selectProduct =0;
            for(var i=0;i<datas.length;i++){
                this.totalMoney+=(datas[i].quantity*datas[i].serviceItem.unitPrice);
                this.selectProduct+= datas[i].quantity
              }
              this.totalMoney =this.totalMoney.toFixed(2);
          },
           handleCheckAllChange() {
             this.$refs.multipleTable.toggleAllSelection()
          },
          toggleSelection(rows) {
            //debugger
           this.checked =false;
              this.$refs.multipleTable.clearSelection();
          },
           getHeight() {
             if(document.body.scrollHeight > window.innerHeight){
                this.isFixed =true;
              }else{
                this.isFixed =false;
              }
               //this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
            console.log(this.scroll)
          },
          //购物车为空市，点击跳转至商城主页
          openGoodList(){
             this.$router.push('/goodsList');
          },
          openDetails(row) {
            window.open("#/goodsDetails?id="+row.serviceItem.id);
          },
          //购物车结算按钮
          statement() {
            if(this.multipleSelection.length>0){
              var tempArr = this.multipleSelection;
              var ids =[];
              for(var i=0;i<tempArr.length;i++){
                if(tempArr.length>0){
                  ids.push(tempArr[i].id);
                }
                  
              }
              var that = this;
              //结算是创建商品订单
              axios.post('/mallApi/mall/order/create', {
                  'shopCartIds': ids.join()
                },{headers:{"token": localStorage.getItem("Authorization")}}).then(res => {
                  res = res.data;
                    if(res.success){
                      this.$router.push({path: '/orderconfirm', query: {"orderId":res.result.id}})
                    }else {
                      if(res.code == 401 || res.code == 400) {
                           http.setLocalStorge();
                          this.$router.push({path: '/login'});
                        }else{
                           that.$message({
                            showClose: true,
                            message: '操作失败！',
                            type: 'error'
                          });
                        }
                    }
              });
            }else{
                  this.$message({
                    showClose: true,
                    message: '请您至少选择1件商品！',
                    
                  });
            }
          },
          handleChange(scope) {
           // debugger
            //this.countNum(scope)
            console.log(scope);
            this.updatePorductNum(scope);
           
          },
          //修改商品数量
          updatePorductNum(scope) {
            if(scope.row.quantity == 0){
              this.$message({
                    showClose: true,
                    message: '请您至少选择1件商品！',
                    
                  });
            }else{
              var _this = this;
              var obj = {
                  "amount": 0,
                  "companyId": scope.row.companyId,
                  "createBy": scope.row.createBy,
                  "createTime": scope.row.createTime,
                  "id": scope.row.id,
                  "orderId": "",
                  "quantity":scope.row.quantity- scope.row.oldQuantity,
                  "serviceItemId":  scope.row.serviceItemId,
                  "status": scope.row.status,
                  "unitPrice": 0,
                  "updateBy": "",
                  "updateTime": ""
                }
              console.log(obj);
              axios.post('/mallApi/mall/shopCart/add',obj,{headers:{"token": localStorage.getItem("Authorization")}}).then((res) => {
              // debugger
                res = res.data;
                if(res.success){
                  this.$message({
                    showClose: true,
                    message: '操作成功！',
                    type: 'success'
                  });
                  this.getCartNum();
                }else {
                  if(res.code == 401 || res.code == 400) {
                      http.setLocalStorge();
                      this.$router.push({path: '/login'});
                  }else{
                    this.$message({
                      showClose: true,
                      message: '操作失败！',
                      type: 'error'
                    });
                  }
                }
              });
            }
          }, 
          showTips(obj){
            let off = obj.target.offsetHeight;
            let  sHeight = obj.currentTarget.scrollHeight;
            sHeight > off? this.showTip = false : this.showTip = true
          }
        },
        components:{
          mallHeader,
          mallFooter,
          mallBread,
          
        }
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// Cart.vue?60857364